import React, { useCallback, useState } from 'react';
import { ButtonProps } from '@material-ui/core/Button';

import { Button, ModalConfirm, Action } from '../../..';

type PropsButton = ButtonProps & {
  title?: string;
  children?: React.ReactNode;
  onConfirm: () => void;
  disable?: boolean;
  isButton?: boolean;
  icon?: React.ReactNode;
};

const ButtonConfirm = ({
  isButton, title, children, onConfirm, disable, ...props
}: PropsButton) => {
  const [confirmOpened, setConfirmOpened] = useState(false);

  const clickHandler = useCallback(() => {
    setConfirmOpened(true);
  }, [setConfirmOpened]);

  const closeHandler = useCallback(() => {
    setConfirmOpened(false);
  }, [setConfirmOpened]);

  const confirmHandler = useCallback(() => {
    closeHandler();
    onConfirm();
  }, [closeHandler, onConfirm]);

  return (
    <>
      {isButton
        ? (
          <Button
            title={title}
            disabled={disable}
            onClick={clickHandler}
            {...props}
          >
            {children}
          </Button>
        )
        : <Action onClick={clickHandler} title={title} {...props} />}
      <ModalConfirm
        open={confirmOpened}
        onClose={closeHandler}
        onCancel={closeHandler}
        onConfirm={confirmHandler}
      />
    </>
  );
};

export default ButtonConfirm;
